import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import SurveyQuestionsTable from './SurveyQuestionsTable';
import SurveyQuestionsTableActions from './SurveyQuestionsTableActions';
import SurveyQuestionsModal from './SurveyQuestionsModal';
import Spinner from 'react-bootstrap/Spinner';

const SurveyQuestions = ({ }) => {

    const [openedModal, setOpenedModal] = useState(null);
    const [questionsData, setQuestionsData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getSurveyQuestions();
    }, []);

    const getSurveyQuestions = async () => {
        setLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}encuesta-item/listar`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error en el Servidor');
            }
        }).then(data => {
            setQuestionsData(data);
            setLoading(false);
        }).catch(err => {
            setQuestionsData([]);
            setLoading(false);
            console.log(err);
        });
    }


    return (
        <Card>
            <CardBody>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="btn btn-primary text-white"
                        onClick={() => {
                            setOpenedModal(true);
                        }}
                    >
                        Crear
                    </Button>
                </div>
                <SurveyQuestionsModal opened={openedModal} closeModal={() => setOpenedModal(false)} questionData={null} Callback={() => getSurveyQuestions()} />
                <br />

                {
                    loading != true ? <SurveyQuestionsTable reactTableData={questionsData} ReactTableActions={SurveyQuestionsTableActions} Callback={() => getSurveyQuestions()} /> :
                        <div className="text-center">
                            <Spinner animation="border" variant="success" />
                        </div>
                }


            </CardBody>
        </Card>)
}

export default SurveyQuestions;